/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { CompanyProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const companyProcessFetchCompanyProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const companyProcessFetchCompanyProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [CompanyProcessTypes.COMPANY_PROCESS_FETCH_COMPANY_PROCESS_LOADING]: companyProcessFetchCompanyProcessLoading,
  [CompanyProcessTypes.COMPANY_PROCESS_FETCH_COMPANY_PROCESS_SUCCESS]: companyProcessFetchCompanyProcessSuccess
});
